import { InCellTabDirective } from './incell-tab.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    InCellTabDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InCellTabDirective
  ]
})
export class SharedModule { }
